<nrk-window #pfspoChartWin (endResize)="onResize($event)">
  <nrk-header><b>PFSPO Charts</b></nrk-header>
  <nrk-content>

    <h3 style="text-align:center"> {{selectedSpo.fpCode}}; {{selectedSpo.fpName}}; {{selectedSpo.fpDimensions}}</h3>

    <div class="legend">
      <div class="legend-line">
        <b>(1) Total Q:</b>
        <div class="legend-item ml-3">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.unconfirmed }"></div>Unconfirmed
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.confirmedPlanned }"></div>Conf. & Planned
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.confirmedEnRoute }"></div>Conf. & En Route
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.fullyOnStock }"></div>On Stock
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.partiallyAvailable }"></div>Partially Available
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.fullQAssigned }"></div>Q Assigned
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.completelyDelivered }"></div>Completely Delivered
        </div>            
      </div>
      <div class="legend-line">
        <b>(2) Total Q Allocation:</b>
        <div class="legend-item ml-3">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.completelyDelivered }"></div>Delivered
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.fullQAssigned }"></div>Assigned
        </div>
        <div class="legend-item">
          <div class="rounded-box" [ngStyle]="{ 'background-color': parent.colors.fullyOnStock }"></div>Free
        </div>
      </div>
      <div class="legend-line">
        <b class="mr-3">Quantity Unit:</b><span>{{['Pieces', 'Square Meters', 'Linear Meters'][parent.showSqm]}}</span>
      </div>
    </div>

    <!-- isOpen: {{pfspoChartWin.isOpen}}, width: {{width}}, height: {{height}}, options: {{options | json}} -->
    <div *ngIf="pfspoChartWin.isOpen" echarts [options]="options" [initOpts]="{ renderer: 'svg' }" [ngStyle]="{width: width + 'px', height: height + 'px'}" class="pfspo-chart"></div>

  </nrk-content>
</nrk-window>


